// For v2 of the seismic submittal tool
import axios from 'axios';
import ShortUniqueId from 'short-unique-id';
import { debounce } from 'lodash';

const uid = new ShortUniqueId();

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

let fetchPromise = null;

export default {
    namespaced: true,

    state: {
        loaded: false,
        id: null, // standards table primary key
        standards: [],
    },
    getters: {
        loaded(state) {
            return state.loaded;
        },
        id(state) {
            return state.id;
        },
        standards(state) {
            return state.standards;
        },
        standardId(state) {
            // return the id used for foreign key lookups
            var id = state.id;

            let standards = state.standards.filter(function(standard) {
                return id == standard.id;
            });

            return standards.length > 0 ? parseInt(standards[0].standardId) : null;
        },
        standardName(state){
            var id = state.id;

            let standards = state.standards.filter(function(standard) {
                return id == standard.id;
            });

            return standards.length > 0 ? standards[0].name : '';
        },
    },
    actions: {
        load({commit}) {
            return axios.get('/actions/seismic-submittal/standards')
                .then(r => commit('setStandards', r.data));
        },
        setIdFromRecord ({commit}, payload) {
            if (!payload) {
                return null;
            }
            
        	return this.dispatch('submittalDesign/show', {id:payload}).then(({data:data}) => {
        		if (data) {
                    // set standard store state.id from design.standardId
        			commit('storeId', data.data.standardId); 
        			return data.data.standardId;
        		}
        	})
            .catch(() => {});
        },
        setId({commit}, payload) {
            commit('storeId', payload);
        },
    },
    mutations: {
        storeId(state, payload) {
            state.id = parseInt(payload);
        },
        setStandards(state, payload) {
            state.loaded = true;
            state.standards = payload;
        },
    },
};